var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 18.6H50.275V4.75V4.35H49.875H45.125H44.725V4.75V18.6H31.275V4.75V4.35H30.875H26.125H25.725V4.75V18.6H23.75C22.3841 18.6 21.0742 19.1426 20.1084 20.1084C19.1426 21.0742 18.6 22.3841 18.6 23.75L18.6 38L18.6 38.0007C18.6079 42.7217 20.3356 47.2782 23.46 50.8176C26.5063 54.2687 30.677 56.5223 35.225 57.183V71.25V71.65H35.625H40.375H40.775V71.25V57.183C45.323 56.5223 49.4937 54.2687 52.54 50.8176C55.6644 47.2782 57.3921 42.7217 57.4 38.0007V38V23.75C57.4 22.3841 56.8574 21.0742 55.8916 20.1084C54.9258 19.1426 53.6159 18.6 52.25 18.6ZM51.85 38C51.85 41.6732 50.3908 45.1961 47.7934 47.7934C45.1961 50.3908 41.6732 51.85 38 51.85C34.3268 51.85 30.8039 50.3908 28.2066 47.7934C25.6092 45.1961 24.15 41.6732 24.15 38V24.15H51.85V38Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrom);
export default __webpack_public_path__ + "static/media/strom.1e7e4efd3acc9150bcb09ad9c12471e5.svg";
export { ForwardRef as ReactComponent };